import * as React from "react";
import * as ReactDOM from "react-dom";
import {resourceStrings} from "./Strings";

export interface TooltipControlProps extends React.Props<TooltipControl> {
    className?: string;
    tipId?: string;
    anchorBorder: Borders;
}

interface LayoutBox {
    top: number;
    left: number;
    width: number;
    height: number;
}

const latestMarker = "shown";

class FlexLayoutBox implements LayoutBox {
    constructor(public top: number, public left: number, public width: number, public height: number) {
    }

    public bottom() {
        return this.top + this.height;
    }

    public right() {
        return this.left + this.width;
    }

    private inside(top: number, left: number): boolean {
        return this.top <= top && top <= this.bottom() && this.left <= left && left <= this.right();
    }

    public fitsIn(box: FlexLayoutBox): boolean {
        return box.inside(this.top, this.left) && box.inside(this.bottom(), this.right());
    }

    public moveToFitsIn(box: FlexLayoutBox): FlexLayoutBox {
        if (this.fitsIn(box)) {
            return this;
        }
        let dx = this.left < box.left ? box.left - this.left :
            (this.right() > box.right() ? box.right() - this.right() : 0);
        let dy = this.top < box.top ? box.top - this.top :
            (this.bottom() > box.bottom() ? box.bottom() - this.bottom() : 0);
        return new FlexLayoutBox(this.top + dy, this.left + dx, this.width, this.height);
    }
}

export enum Borders {
    Top,
    Left,
    Right,
    Bottom
}

export class TooltipControl extends React.Component<TooltipControlProps, any> {
    constructor(props: TooltipControlProps) {
        super(props);
    }

    private static offsetBox($el: JQuery): FlexLayoutBox {
        var offset = $el.offset();
        return new FlexLayoutBox(offset.top, offset.left, $el[0].offsetWidth, $el[0].offsetHeight);
    }

    public anchorTo($anchor: JQuery) {
        let $self = $(this.refs['container']);
        const $box = $self.offsetParent();
        const box = TooltipControl.offsetBox($box);
        const anchorBox = TooltipControl.offsetBox($anchor);
        const selfBox = TooltipControl.offsetBox($self);
        const anchorBorder = this.props.anchorBorder;

        let left = 0;
        let top = 0;

        switch (anchorBorder) {
            case Borders.Left:
                left = anchorBox.right() + 20;
                top = anchorBox.top + anchorBox.height / 2 - selfBox.height / 2;
                break;
            case Borders.Right:
                left = anchorBox.left - 20 - selfBox.width;
                top = anchorBox.top + anchorBox.height / 2 - selfBox.height / 2;
                break;
            case Borders.Bottom:
                top = anchorBox.top - selfBox.height - 20;
                left = anchorBox.left + anchorBox.width / 2 - selfBox.width;
                break;
            case Borders.Top:
                top = anchorBox.bottom() + 20;
                left = anchorBox.left + anchorBox.width / 2 - selfBox.width;
                break;
        }
        let targetBox = new FlexLayoutBox(top, left, selfBox.width, selfBox.height)
            .moveToFitsIn(box);

        // make sure targetBox is inside box

        $self.css({ top: `${targetBox.top - box.top}px`, left: `${targetBox.left - box.left}px` });
    }

    public render(): JSX.Element {
        return (
            <div className={`tool-tip anchor${Borders[this.props.anchorBorder]} ${this.props.className || ''}`}
                onClick={evt => {
                    evt.stopPropagation();
                }}
                ref="container"
                data-tip-id={this.props.tipId}>
                {this.props.className != "modeless" ?
                    <div className="dialog-close-button" onClick={() => this.close() }>
                    </div>
                    : null}
                {this.props.children}
            </div>
            ); 
    }

    private close() {
        $(`.tool-tip[data-tip-id="${this.props.tipId}"]`).toggleClass('hidden', true);
        if (_.has(resourceStrings.tooltips, this.props.tipId)) {
            var key = `tooltip_shown_${this.props.tipId}`;
            localStorage.setItem(key, latestMarker);
        }
    }

    public static renderToolTipAsNeeded(props: TooltipControlProps): JSX.Element {
        var key = `tooltip_shown_${props.tipId}`;
        var prev = localStorage.getItem(key);

        if (!prev || prev !== latestMarker) {
            var tip = (resourceStrings.tooltips as any)[props.tipId];
            var tipContent = tip ? [
                    <h3 key={props.tipId + "-title"}>{tip.title}</h3>,
                    <p key={props.tipId + "-text"}>{tip.text}</p>] : props.children;

            var result = (
                <TooltipControl className={props.className} tipId={props.tipId} ref={props.ref} anchorBorder={props.anchorBorder}>
                    {tipContent}
                </TooltipControl>
                );
            return result;
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/TooltipControl.tsx